import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const FinancialCentsIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.71 6.19H8.26001V7.65H15.71V6.19Z",
                fill: "#001A31"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11.23H8.27002V12.69H12V11.23Z",
                fill: "#001A31"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.71 8.71002H8.26001V10.17H15.71V8.71002Z",
                fill: "#001A31"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.96 16.24L12.02 19.2L9.30002 16.49L7.65002 18.15L12.03 22.5L20.41 14.06V10.75L14.96 16.23V16.24Z",
                fill: "#259245"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.78997 16L5.93997 13.18V3.86001L16.16 3.85001L18.07 5.76001V12.11L20.41 9.77001V4.79001L20.17 4.55001L17.41 1.79001L17.13 1.51001L3.58997 1.53001L3.60997 14.16L7.13997 17.66L8.78997 16.01V16Z",
                fill: "#001A31"
            })
        ]
    });
};
